export default __webpack_public_path__ + "images/RR.6fc4c7c.png";